import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, OnChanges } from '@angular/core';
import { PriceHelper } from "../helpers/PriceHelper";
import { DateHelper } from "../helpers/DateHelper";
import { BaseComponent } from '../classes/BaseComponent';

@Component({
  selector: 'app-price-evolution',
  templateUrl: './price-evolution.component.html',
  styleUrls: ['./price-evolution.component.scss']
})
export class PriceEvolutionComponent extends BaseComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() priceEvolution: string;
  @Input() currency: string;
  priceEvolutionElements: Array<PriceEvolutionElement> = [];

  constructor() {
    super();
  }

  ngOnInit() {

  }

  ngOnChanges() {
    if (this.priceEvolution){
      this.priceEvolutionElements = [];
      const elements = this.priceEvolution.split('~');
      let smallestPriceIndex = 0;
      let smallestPrice = Number.POSITIVE_INFINITY;
      for (let i = 0; i < elements.length; i++){
        const el = elements[i];
        const date = el.split(':')[0];
        const indicator = el.split(':')[1][0];
        let price = el.split(':')[1];
        if (indicator === '+' || indicator === '-'){
          price = price.substring(1);
        }
        const priceFloat = Number.parseFloat(price);
        this.priceEvolutionElements.unshift(new PriceEvolutionElement(priceFloat, date, indicator));
        if (priceFloat <= smallestPrice){
          smallestPriceIndex = i;
          smallestPrice = priceFloat;
        }
      }
      if (this.priceEvolutionElements.length > 0){
        this.priceEvolutionElements[this.priceEvolutionElements.length - 1 - smallestPriceIndex].isBest = true;
      }
    }
  }

  ngAfterViewInit() {
    this.scrollToRight();
  }

  getDisplayDate(date: string) {
    return DateHelper.serverDateToLocaleDate(date, true);
  }

  getDisplayPrice(price: number) {

    if (price == 0){
      return this.getString("free");
    }

    return PriceHelper.formatPrice(price, this.currency);
  }

  scrollToRight() {
    const priceEvoContainer = document.getElementById("priceEvoContainer");
    if (priceEvoContainer){
      priceEvoContainer.scrollLeft = 11000;
    }
  }

}

export class PriceEvolutionElement {
  price: number;
  date: string;
  indicator: string;
  isBest = false;
  constructor(price, date, indicator){
    this.price = price;
    this.date = date;
    this.indicator = indicator;
  }
}
